import {
  EProgressBarInternalViewModel,
  ProgressBarDesign
} from '@appcharge/shared-ui';

import { EThemes } from '../enums';

import { BlockMetadata } from './types';

const defaultProgressBar: BlockMetadata = {
  id: EProgressBarInternalViewModel.DEFAULT,
  version: '1.0.0',
  name: 'Default',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/progress-bar/default_preview.png'
  ],
  theme: EThemes.ROYAL_BLAST,
  component: ProgressBarDesign
};

export const progressBarsDesigns = {
  defaultProgressBar
};
